module.exports = __webpack_public_path__ + "img/5.4e0c9d22.png";